import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { ArrowBack } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { onTutorialPage } from "../../../redux/slices/tutorialSlice";
import StudentTutorialAPIs from "utilities/api/StudentTutorialAPIs";
import { setOnDetail } from "../../../redux/slices/tutorialSlice";
import { Button } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ListVideoContainer from "./ListVideoContainer";
const VideoCardView = ({ tutorialID }) => {
  const dispatch = useDispatch();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH MODULE ---------------- */

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const data = await StudentTutorialAPIs.ModuleDetailGet(tutorialID);
        setCourse(data);
      } catch (error) {
        console.error("Failed to fetch course:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourse();
  }, [tutorialID]);

  /* ---------------- FORMAT VIDEO LENGTH ---------------- */
const formatDuration = (video_length) => {
  if (!video_length) return "";

  // If already HH:MM:SS
  if (video_length.includes(":")) {
    const [hours, minutes, seconds] = video_length.split(":");

    if (parseInt(hours) > 0) {
      return `${hours}h ${minutes}m`;
    }

    return `${minutes}m`;
  }

  return "";
};


  /* ---------------- HANDLE VIDEO CLICK ---------------- */
  const handleVideoClick = (videoObj) => {
    if (videoObj?.link) {
      window.open(videoObj.link, "_blank", "noopener,noreferrer");
    }
  };

  /* ---------------- LOADING ---------------- */
if (loading || !course) {
    return (
      <Box p={4}>
        <Typography variant="h5">Loading...</Typography>
      </Box>
    );
  }

  const openDocument = () => {
    if (!course?.document) return;

    const doc = course.document;

    if (doc.startsWith("http")) {
      window.open(doc, "_blank");
    } else {
      window.open(`${process.env.REACT_APP_API_BASE_URL}${doc}`, "_blank");
    }
  };
  //open document




  /* ---------------- UI ---------------- */

  return (
    <Box p={3}>
     {/* Header */}
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 4,
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
    <IconButton

onClick={() => dispatch(onTutorialPage(false))}
    >
      <ArrowBack />
    </IconButton>
    <Typography variant="h5" sx={{ fontWeight: 600 }}>
      {course.name}
    </Typography>
  </Box>

  {/* Document Button */}
  {course?.document && (
    <Button
      variant="outlined"
      startIcon={<DescriptionIcon />}
      onClick={openDocument}
      sx={{
        color: "#1976d2",
        borderColor: "#1976d2",
        textTransform: "none",
        fontWeight: 500,
        fontSize: "15px",
        borderRadius: 1,
        px: 3,
        py: 1,
        "&:hover": {
          borderColor: "#1565c0",
          color: "#1565c0",
          backgroundColor: "#f5f9ff",
        },
      }}
    >
      Document
    </Button>
  )}
</Box>





          
      


      {/* Video List */}
    <ListVideoContainer
  videos={course.videos.map(v => v.video)}
  onVideoClick={(video) => {
    if (video?.link) {
      window.open(video.link, "_blank", "noopener,noreferrer");
    }
  }}
/>
    </Box>
  );
};

export default VideoCardView;
